import { useState, useEffect } from 'react';

const VIEWPORT_FALLBACK = '100%';

const getViewportWidth = () => {
  if (typeof window === 'undefined') {
    return VIEWPORT_FALLBACK;
  }

  return `${window.visualViewport?.width ?? window.innerWidth}px`;
};

export const NewsletterBackground = ({ bg_url }: { bg_url: string }) => {
  const [windowWidth, setWindowWidth] = useState<string>(VIEWPORT_FALLBACK);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setWindowWidth(getViewportWidth());
    };

    window.addEventListener('resize', handleResize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
    }

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  return (
    <div
      // eslint-disable-next-line tailwindcss/no-arbitrary-value
      className="absolute inset-0 left-[calc(-50vw+50%)] z-0 bg-right bg-no-repeat bg-[#a8dbde] sm:bg-cover sm:bg-center"
      style={{
        width: windowWidth,
        backgroundImage: bg_url,
      }}
    ></div>
  );
};
